import React from 'react';
import {
  Box,
  Container,
  Typography,
  Grid,
  Paper,
  Stack,
} from '@mui/material';
import {
  Gavel,
  Security,
  People,
  Language,
} from '@mui/icons-material';

const features = [
  {
    icon: Gavel,
    title: 'Expert Legal Guidance',
    description: 'Our team of experienced immigration lawyers provides comprehensive legal support for all UK visa categories.',
  },
  {
    icon: Security,
    title: 'Trusted Service',
    description: 'We maintain the highest standards of professionalism and confidentiality in handling your immigration matters.',
  },
  {
    icon: People,
    title: 'Personalized Approach',
    description: 'Every case is unique. We provide tailored solutions that address your specific immigration needs.',
  },
  {
    icon: Language,
    title: 'Multilingual Support',
    description: 'We offer services in English, Urdu, Punjabi, Pothwari, and Hindi for clear communication.',
  },
];

const About = () => {
  return (
    <Box sx={{ py: 8 }}>
      <Container maxWidth="lg">
        {/* Header Section */}
        <Box sx={{ textAlign: 'center', mb: 8 }}>
          <Typography variant="h1" gutterBottom>
            About Chishty UK Immigration Law
          </Typography>
          <Typography variant="h5" color="textSecondary" sx={{ mb: 4 }}>
            Your Trusted Partner for UK Immigration Solutions
          </Typography>
        </Box>

        {/* Main Content */}
        <Grid container spacing={6}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Who We Are
            </Typography>
            <Typography paragraph>
              Chishty UK Immigration Law is a leading immigration law firm specializing in UK visa and immigration services. 
              With years of experience in the field, we have successfully helped numerous individuals, families, and businesses 
              navigate the complex UK immigration system.
            </Typography>
            <Typography paragraph>
              Our commitment to excellence and client satisfaction has made us a trusted name in immigration law. We understand 
              that each immigration journey is unique, and we strive to provide personalized solutions that meet your specific needs.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4" gutterBottom>
              Our Mission
            </Typography>
            <Typography paragraph>
              Our mission is to provide expert, reliable, and comprehensive immigration services that help our clients achieve 
              their goals of living, studying, working, or doing business in the UK. We are dedicated to making the immigration 
              process as smooth and stress-free as possible.
            </Typography>
            <Typography paragraph>
              We believe in building long-term relationships with our clients based on trust, transparency, and successful outcomes. 
              Our team stays up-to-date with the latest changes in UK immigration law to ensure you receive the most current advice.
            </Typography>
          </Grid>
        </Grid>

        {/* Features Section */}
        <Box sx={{ mt: 8 }}>
          <Typography variant="h4" align="center" gutterBottom>
            Why Choose Us
          </Typography>
          <Grid container spacing={4} sx={{ mt: 2 }}>
            {features.map((feature) => {
              const IconComponent = feature.icon;
              return (
                <Grid item xs={12} sm={6} md={3} key={feature.title}>
                  <Paper sx={{ p: 3, height: '100%' }}>
                    <Stack spacing={2} alignItems="center" textAlign="center">
                      <IconComponent sx={{ fontSize: 48, color: 'primary.main' }} />
                      <Typography variant="h6">{feature.title}</Typography>
                      <Typography color="textSecondary">
                        {feature.description}
                      </Typography>
                    </Stack>
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>

        {/* Office Hours Section */}
        <Box sx={{ mt: 8, textAlign: 'center' }}>
          <Typography variant="h4" gutterBottom>
            Office Hours
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Monday – Friday: 9:00 AM – 5:30 PM
          </Typography>
          <Typography variant="body1" color="textSecondary">
            Saturday & Sunday: By Appointment Only
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default About; 